var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.31 17.39L.33 15.56 6.67 8.7.33 1.83 2.31 0l8.03 8.7-8.03 8.69z"}));
}

ChevronRight.defaultProps = {"width":"10.67","height":"17.39","viewBox":"0 0 10.67 17.39"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
